import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { usePaywall } from "./PaywallContext";

const TIER_ORDER = { free: 0, adventure: 1, premium: 2 };

/**
 * Route guard that checks user.tier >= required. If the user lacks the tier,
 * redirects to /pricing and opens the paywall modal so the lock-out isn't
 * a silent dead end. Admins bypass the gate.
 */
export default function TierGuard({ required = "adventure", feature, children }) {
    const { user, loading } = useAuth();
    const { openPaywall } = usePaywall();
    const allowed =
        !user
            ? false
            : user.role === "admin" ||
              (TIER_ORDER[user.tier || "free"] ?? 0) >= (TIER_ORDER[required] ?? 1);

    useEffect(() => {
        if (!loading && user && !allowed) {
            openPaywall({
                required_tier: required,
                feature: feature || "access this feature",
            });
        }
    }, [loading, user, allowed, openPaywall, required, feature]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-alpine-mist">
                <div className="w-10 h-10 border-4 border-ember-orange border-t-transparent rounded-full animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    if (!allowed) return <Navigate to="/pricing" replace />;
    return children;
}
